import { PhoneCallDto, PhoneCallOption } from '@mark43/cad-api';
import { formatHoursMinutesSeconds, formatMonthDayYear } from '../common/helpers/utils';

function buildPhoneCallLabel(phoneCall: PhoneCallDto) {
    const createdDate = phoneCall.createdDateUtc;
    return [
        phoneCall.labelPrefix,
        createdDate ? formatMonthDayYear(createdDate) : undefined,
        createdDate ? formatHoursMinutesSeconds(createdDate) : undefined,
    ]
        .filter((x) => !!x)
        .join(' ');
}

export function sortPhoneCallDtosByCreatedDate(phoneCallDtos: PhoneCallDto[]) {
    const copy = phoneCallDtos.slice();
    copy.sort((a, b) => {
        return a.createdDateUtc > b.createdDateUtc
            ? -1
            : b.createdDateUtc < a.createdDateUtc
            ? 1
            : 0;
    });
    return copy;
}

export function phoneCallDtoToPhoneCallOption(phoneCallDto: PhoneCallDto): PhoneCallOption {
    return {
        label: buildPhoneCallLabel(phoneCallDto),
        value: phoneCallDto.id,
        phoneNumberId: phoneCallDto.phoneNumberId!,
    };
}
